module.exports = __webpack_public_path__ + "img/coupon_b.369d4429.png";